import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { items } from '../../items';
import { svg } from '../../assets/svg';
import { theme } from '../../constants';
import { components } from '../../components';
import { SHOPIFY_STORES } from '../../config';



export const Profile: React.FC = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('shopifyUser') || '{}');

  useEffect(() => {
    window.scrollTo(0, 0);

    const tokenFromLocal = typeof window !== 'undefined' ? localStorage.getItem('customerAccessToken') : null;
    const tokenFromCookie = Cookies.get('customerAccessToken');
    const token = tokenFromLocal || tokenFromCookie;
    console.log("🪙 Token (localStorage|cookie):", tokenFromLocal, tokenFromCookie);

    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  // Function to handle logout (reused for deletion cleanup)
  const handleLogout = () => {
    Cookies.remove('customerAccessToken');
    Cookies.remove('isLoggedIn');
    Cookies.remove('customerId');
    Cookies.remove('loggedInStoreKey');

    try {
      localStorage.removeItem('shopifyUser');
      localStorage.removeItem('customerAccessToken');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('customerId');
      localStorage.removeItem('loggedInStoreKey');
    } catch (e) {
      // ignore
    }

    navigate('/');
  };

const handleDeleteAccount = async () => {
  const confirmation = window.confirm(
    '⚠️ Are you sure you want to delete your account? '
  );
  if (!confirmation) return;

  const customerAccessToken =
    Cookies.get('customerAccessToken') || localStorage.getItem('customerAccessToken');

  if (!customerAccessToken) {
    alert('Error: Missing access token. Please sign in again.');
    return;
  }

  // Get the store key the user logged in with
  const storeKey = localStorage.getItem('loggedInStoreKey') || Cookies.get('loggedInStoreKey') || 'USA';
  const storeConfig = SHOPIFY_STORES[storeKey as keyof typeof SHOPIFY_STORES] || SHOPIFY_STORES.USA;

  try {
    // Step 1: Change only email, append $ to make it unusable
    const currentEmail = user?.email || `deleted-${Date.now()}@example.com`;
const [localPart, domain] = currentEmail.split('@');
const newEmail = `${localPart}+deleted${Date.now()}@${domain}`;


    const mutation = `
      mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
          customer {
            id
            email
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    const variables = {
      customerAccessToken,
      customer: {
        email: newEmail,
      },
    };

    const response = await fetch(
      storeConfig.url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storeConfig.token,
        },
        body: JSON.stringify({ query: mutation, variables }),
      }
    );

    const result = await response.json();
    const errors = result.data?.customerUpdate?.userErrors;

    if (errors && errors.length > 0) {
      console.error('Deletion failed:', errors);
      alert(`Account deletion failed: ${errors[0].message}`);
      return;
    }

    console.log('deleted account:', result.data?.customerUpdate?.customer);

    // Step 2: Revoke customer access token
    const revokeMutation = `
      mutation customerAccessTokenDelete($customerAccessToken: String!) {
        customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
          deletedAccessToken
          deletedCustomerAccessTokenId
          userErrors {
            field
            message
          }
        }
      }
    `;

    const revokeVariables = { customerAccessToken };

    const revokeResponse = await fetch(
      storeConfig.url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storeConfig.token,
        },
        body: JSON.stringify({ query: revokeMutation, variables: revokeVariables }),
      }
    );

    const revokeResult = await revokeResponse.json();
    const revokeErrors = revokeResult.data?.customerAccessTokenDelete?.userErrors;

    if (revokeErrors && revokeErrors.length > 0) {
      console.error('Token revocation failed:', revokeErrors);
      alert(`Error logging out: ${revokeErrors[0].message}`);
      return;
    }

    // Step 3: Clear local data
    Cookies.remove('customerAccessToken');
    Cookies.remove('isLoggedIn');
    Cookies.remove('customerId');
    localStorage.removeItem('shopifyUser');
    localStorage.removeItem('customerAccessToken');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('customerId');

    alert('Your account has been deleted successfully.');
    navigate('/');
  } catch (error) {
    console.error('Error deleting account:', error);
    alert('Network error. Please try again later.');
  }
};



  
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        burger={true}
        basket={true} 
        line={true}
      />
    );
  };

  const renderUserInfo = (): JSX.Element => {
    return (
      <div>
        <h2
          style={{
            fontSize: 28,
            textAlign:'center',
            fontWeight: 'bold',
            color: theme.colors.mainColor,
            margin: '0 0 18px 20px',
            letterSpacing: 1,
            ...theme.fonts.Mulish_700Bold,
          }}
        >
          My profile
        </h2>
        <div
          style={{
            marginBottom: 29,
            display: 'flex',
            flexDirection: 'column',
            padding: '0 20px',
          }}
        >
          <h3
            style={{
              fontSize: 20,
              marginBottom: 4,
              fontWeight: 'bold',
              ...theme.fonts.Mulish_700Bold,
              color: theme.colors.mainColor,
            }}
          >
            {user?.firstName || 'Guest User'}
          </h3>
          <span
            style={{
              fontSize: 14,
              lineHeight: 1.5,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
            }}
          >
            {user?.email || 'guest@example.com'}
          </span>
        </div>
      </div>
    );
  };


  const renderMenu = (): JSX.Element => {
    return (
      <>
        <items.ProfileItem
          title='Personal info'
          icon={<svg.UserSvg />}
          onClick={() => navigate('/EditProfile')}
        />
        
        {/* NEW: Account Deletion Item */}
        <items.ProfileItem
          title='Delete Account'
          icon={<svg.TrashSvg />} // Assuming you have a Trash/Delete icon SVG
          onClick={handleDeleteAccount}
          navIcon={false}
          // Highlight deletion as a serious action
        />
        
        <items.ProfileItem
          title='Sign out'
          icon={<svg.LogOutSvg />}
          onClick={handleLogout} // Use the consolidated handleLogout function
          navIcon={false}
        />
      </>
    );
  };

  const renderContent = () => {
    return (
      <div style={{ paddingTop: 40, paddingBottom: 64 + 30 }}>
        {renderUserInfo()}
        {renderMenu()}
      </div>
    );
  };

  const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};